// ============================================
// AI 텍스트 생성 프롬프트 빌더 (공지 / 문자 / 자동메시지)
// 단일 JSON 결과 반환 ({ title?, content })
// ============================================

const LANGUAGE_NAMES = {
  ko: 'Korean (한국어)',
  en: 'English',
};

function buildPersona() {
  return `너는 실제 동네 체육관에서 회원에게 보낼 메시지를 작성하는 사람이야.
[공통 규칙]:
- 정중하고 친절한 말투를 사용해.
- 한 문장이 끝나면 \\n을 사용해.
- 실제 체육관에서 가장 자연스러운 톤을 어떤 내용의 톤을 사용할지 생각해서 써.
- 마지막엔 항상 감사합니다.로 마무리해.
`;
}

function buildCommonRules(language) {
  const languageName = LANGUAGE_NAMES[language] || LANGUAGE_NAMES.ko;

  return `- 반드시 ${languageName}로만 작성해.`;
}

function buildDraftHint(currentTitle, currentContent) {
  const parts = [];
  if (currentTitle) parts.push(`현재 제목: ${currentTitle}`);
  if (currentContent) parts.push(`현재 내용: ${currentContent}`);
  if (parts.length === 0) return '';

  return `\n참고용 현재 초안. 제공된 경우 자연스럽게 개선해:\n${parts.join('\n')}\n`;
}

// 공지 프롬프트 //
function buildNoticePrompt(userPrompt, context = {}, language = 'ko') {
  const storeName = context.storeName || '';
  const draftHint = buildDraftHint(context.currentTitle, context.currentContent);

  return `${buildPersona()}

체육관 회원들에게 보낼 공지를 작성해줘.
관리자 요청: ${userPrompt}
${draftHint}

[작성 규칙]
${buildCommonRules(language)}
- 항상 인사말로 시작해. (ex. 안녕하세요. ${storeName}입니다.)
- "title"과 "content"를 담은 JSON으로 반환해.
- 제목은 명확하고 간결해야 해.
- 내용은 문자보다 약간 길어도 돼.
- 이모지는 자연스러울 때만 허용하되, 기본적으로는 쓰지 마.
- 톤은 앱 공지, 게시판, 카카오 채널 게시글에 어울리게.

위 요청을 바탕으로 작성해줘.
JSON 객체만 반환해:{"title":"title","content":"line1\\nline2\\nline3"}`;
}

// 문자(SMS) 프롬프트 //
function buildMessagePrompt(userPrompt, context = {}, language = 'ko') {
  const storeName = context.storeName || '';
  const draftHint = buildDraftHint('', context.currentContent);

  return `${buildPersona()}

체육관 회원들에게 보낼 짧은 문자(SMS)를 작성해줘.
관리자 요청: ${userPrompt}
${draftHint}

[작성 규칙]
${buildCommonRules(language)}
- 항상 인사말로 시작해. (ex. 안녕하세요. ${storeName}입니다.)
- "content"만 담은 JSON으로 반환해.
- 약 5줄 내외로 짧고 읽기 쉽게.
- 이모지 금지.
- 사용자가 특별히 요청하지 않는 한 제목은 넣지 마.

위 요청을 바탕으로 작성해줘.
JSON 객체만 반환해:
{"content":"line1\\nline2\\nline3"}`;
}

// 자동메시지 / 자동 알림 프롬프트 //
function buildAutoMessagePrompt(userPrompt, context = {}, language = 'ko') {
  const purposeHint = context.purpose ? `\n메시지 목적: ${context.purpose}` : '';
  const draftHint = buildDraftHint('', context.currentContent);

  return `${buildPersona()}

자동으로 발송되는 체육관 메시지를 작성해줘.${purposeHint}
관리자 요청: ${userPrompt}
${draftHint}

[작성 규칙]
${buildCommonRules(language)}
- "content"만 담은 JSON으로 반환해.
- 이모지 금지.

위 요청을 바탕으로 작성해줘.
JSON 객체만 반환해:
{"content":"line1\\nline2\\nline3"}`;
}

export function buildTextPrompt({ type, userPrompt, context = {}, language = 'ko' }) {
  if (type === 'message') return buildMessagePrompt(userPrompt, context, language);
  if (type === 'autoMessage') return buildAutoMessagePrompt(userPrompt, context, language);
  return buildNoticePrompt(userPrompt, context, language);
}
